
// ROUTES
require('modules/report/routes/report');

// CONTROLLERS
require('modules/report/controllers/report');
require('modules/report/controllers/list');

// SERVICES
require('modules/report/services/report');
require('modules/report/services/list');


angular.module('unica_report', [

	// ROUTES
	'unica_report.report_routes',

	// CONTROLLERS
	'unica_report.report_controllers',


	// SERVICES
	'unica_report.report_services'

]);